<template>
  <v-container class="mt-6">
    <div v-if="!allRequirementsFulfilled">
      <span
        class="text-h6 text-md-h5 grey--text text--darken-2 font-weight-light"
        >{{ preTitle }}</span
      >
      <h1 class="text-h5 text-md-h3 mb-0 mb-md-9" :class="fontWeightLightMd">
        {{ title }}
      </h1>
    </div>
    <div v-else>
      <h1 class="text-h5 text-md-h3 mb-0 mb-md-9" :class="fontWeightLightMd">
        {{ preTitle }}
      </h1>
      <v-alert rounded="lg" type="success" color="light-green darken-1" text>
        <v-row align="center">
          <v-col cols="7"
            ><h1 class="text-h6 text-md-h4" :class="fontWeightLightMd">
              {{ title }}
            </h1></v-col
          >
          <v-col cols="5"
            ><v-btn
              v-if="allRequirementsFulfilled"
              to="Requests"
              class="mx-2"
              fab
              dark
              color="identity white--text lg"
            >
              <v-icon dark>
                mdi-chevron-right
              </v-icon>
            </v-btn></v-col
          >
        </v-row>
      </v-alert>
    </div>

    <courses></courses>

    <v-alert
      rounded="lg"
      type="success"
      color="light-green darken-1"
      class="mt-3"
      text
      v-if="allRequirementsFulfilled"
    >
      {{ docsCompleteMsg }}
    </v-alert>

    <v-snackbar v-model="snackbar">
      {{ docsCompleteMsg }}
      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>

    <div
      v-if="allRequirementsFulfilled"
      class="d-flex justify-center align-center mt-3"
    >
      <v-btn to="Requests" color="identity--text" text>{{
        $t('requirements.btnTitle')
      }}</v-btn>
      <v-btn
        to="Requests"
        class="mx-2"
        fab
        dark
        color="identity white--text lg"
      >
        <v-icon dark>
          mdi-chevron-right
        </v-icon>
      </v-btn>
    </div>

    <v-overlay :value="isVisibleOverlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import Courses from '@/components/resources/Courses'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Requirements',
  data: () => ({
    snackbar: false,
    docsCompleteMsg: '¡Gracias! Tu constancias están completas.'
  }),
  components: {
    Courses
  },
  computed: {
    ...mapGetters('requirements', [
      'allRequirementsFulfilled',
      'isVisibleOverlay'
    ]),
    fontWeightLightMd() {
      return this.$vuetify.breakpoint.mdAndUp ? 'font-weight-light' : ''
    },
    preTitle() {
      return this.allRequirementsFulfilled
        ? this.$t('requirements.preTitleFulfilled')
        : this.$t('requirements.preTitle')
    },
    title() {
      return this.allRequirementsFulfilled
        ? this.$t('requirements.titleFulfilled')
        : this.$t('requirements.title')
    }
  },
  watch: {
    allRequirementsFulfilled(fulfilled) {
      if (fulfilled) {
        this.addSectionCompleted('b')
        this.enableRoute('Requests')
      } else {
        this.removeSectionCompleted('b')
        this.disableRoute('Requests')
      }
    }
  },
  methods: {
    ...mapActions('routes', ['enableRoute', 'disableRoute']),
    ...mapActions('user', ['addSectionCompleted', 'removeSectionCompleted'])
  }
}
</script>
